import { graphql } from '@prophecy/graphql-types/graphql';
// Initialize the in-memory search cache (fire-and-forget)
// Call this when user focuses on the search bar
export const InitializeInMemorySearchQuery = graphql(`
  query InitializeInMemorySearch {
    InitializeInMemorySearch {
      started
      cached
    }
  }
`);
// Main search query - returns results separated by name and column matches
export const InMemorySearchQuery = graphql(`
  query InMemorySearch($query: String!, $entityKinds: [EntityKind!], $projectIds: [Long!], $offset: Int, $limit: Int) {
    InMemorySearch(query: $query, entityKinds: $entityKinds, projectIds: $projectIds, offset: $offset, limit: $limit) {
      nameResults {
        entityId
        entityKind
        name
        sourceName
        projectId
        projectName
        branch
        createdAt
        matchedTerms {
          searchType
          term
        }
      }
      columnResults {
        entityId
        entityKind
        name
        sourceName
        projectId
        projectName
        branch
        createdAt
        matchedTerms {
          searchType
          term
        }
      }
      totalNameResultsCount
      totalColumnResultsCount
    }
  }
`);
// Get filters for the search result
export const InMemorySearchFiltersQuery = graphql(`
  query InMemorySearchFilters($query: String!) {
    InMemorySearchFilters(query: $query) {
      entityFilters {
        entityKind
        displayName
        hitCount
      }
      projectFilters {
        projectId
        projectName
        hitCount
      }
      totalNameHits
      totalColumnHits
    }
  }
`);
